"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetStatus = void 0;
var react_1 = require("react");
var profile_api_1 = require("@l2p/profile-api");
var ui_components_1 = require("@l2p/ui-components");
var useGetStatus = function () {
    return (0, react_1.useCallback)(function (status) {
        if (status === profile_api_1.BonusCardStatus.CanceledByUser ||
            status === profile_api_1.BonusCardStatus.CanceledByAdmin ||
            status === profile_api_1.BonusCardStatus.Lose ||
            status === profile_api_1.FreeRoundStatus.CanceledByUser ||
            status === profile_api_1.FreeRoundStatus.CanceledByAdmin)
            return ui_components_1.StatusType.error;
        if (status === profile_api_1.BonusCardStatus.Win ||
            status === profile_api_1.FreeRoundStatus.Finished ||
            status === profile_api_1.BonusCardStatus.InProgress ||
            status === profile_api_1.FreeRoundStatus.InProgress)
            return ui_components_1.StatusType.success;
        return ui_components_1.StatusType.warning;
    }, []);
};
exports.useGetStatus = useGetStatus;
